export default __webpack_public_path__ + "c501c39d3121f428ee8170f231494c6b.png";